import { Box, Card, CardContent, Typography } from "@mui/joy";
import { EstimateContractTabs } from ".";

export default function EstimateContract(props: any) {
    const { measurements, attributes, setIsNextStageEligible } = props;
    return (
        <Box>
            <Box mt={2}>
                <EstimateContractTabs measurements={measurements} attributes={attributes} setIsNextStageEligible={setIsNextStageEligible} />
            </Box>
        </Box>
    );
}
